import React, { useEffect } from "react";
import { HelpCircle, Mail, Phone } from "lucide-react";
import { useGlobal } from "../context/GlobalContext";

const PrivacyPolicy = () => {
  const { getContent, content } = useGlobal();

  useEffect(() => {
    getContent("privacy-policy");
  }, [getContent]);

  return (
    <div className="content-wrapper-main2 ">
      <div className="content-main px-0">
        <div className="content-card shadow-lg border-0 rounded-4 overflow-hidden">
          <div>
            <div className="content-card-body">
              {content ? (
                <>
                  <h3 className="mb-3">{content.title}</h3>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: content.content || "",
                    }}
                  />
                </>
              ) : (
                <div className="p-4 text-center">Loading...</div>
              )}
            </div>

            <div className="mt-4 p-4 rounded-4 bg-white border border-primary border-opacity-25 text-center shadow-sm">
              <HelpCircle size={32} className="text-secondary mb-3" />
              <h5 className="fw-bold">Need Help?</h5>
              <p className="text-muted mb-3">
                If you have any questions regarding our privacy practices,
                please contact our support team.
              </p>
              <div className="d-flex flex-wrap justify-content-center align-items-center gap-2">
                <a
                  href="mailto:support@puretouchhomeservices.com"
                  className="btn btn-outline-primary px-3 py-2 fw-bold d-inline-flex align-items-center gap-2"
                >
                  <Mail size={18} className="flex-shrink-0" />
                  <span>support@puretouchhomeservices.com</span>
                </a>
                <a
                  href="tel:+17632387559"
                  className="btn btn-primary px-3 py-2 fw-bold d-inline-flex align-items-center gap-2"
                >
                  <Phone size={18} className="flex-shrink-0" />
                  <span>763-238-7559</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
